import React, { useContext } from "react"
import { Switch, useRouteMatch, Route, Redirect, Link } from "react-router-dom"
import ListDownloadables from "./ListDownloadables"
import { ProjectContext, UserContext } from "../App"
import styled from "styled-components"
import { Empty, Button } from "antd"
import { FolderAddOutlined } from "@ant-design/icons"
import { Role } from "../graphql-types-global"

const Downloadables = () => {
  const match = useRouteMatch()
  const { activeProject } = useContext(ProjectContext)
  const user = useContext(UserContext)

  return (
    <Switch>
      <Route path={`${match.path}/:projectId`}>
        <ListDownloadables />
      </Route>

      <Route path={match.path} exact>
        {activeProject && <Redirect to={`${match.path}/${activeProject.id}`} />}

        {!activeProject && (
          <EmptyContainer>
            <Empty description="Bitte wählen Sie ein Projekt aus">
              {user?.role === Role.ADMIN && (
                <Link to="/projects/create">
                  <Button type="primary" icon={<FolderAddOutlined />}>
                    Neues Projekt
                  </Button>
                </Link>
              )}
            </Empty>
          </EmptyContainer>
        )}
      </Route>

      <Route path={`${match.path}/*`}>
        <Redirect to="/downloadables" />
      </Route>
    </Switch>
  )
}

const EmptyContainer = styled.div`
  margin-top: 4rem;
`

export default Downloadables
